import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pb-2" }
const _hoisted_2 = { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.open,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
      "max-width": "720px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("連絡メール詳細", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.chat)
                  ? (_openBlock(), _createBlock(_component_v_table, {
                      key: 0,
                      class: "pt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("td", null, "日付", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.date), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("td", null, "宛先", -1)),
                            _createElementVNode("td", _hoisted_1, [
                              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }, "クラス", -1)),
                              _createElementVNode("div", null, _toDisplayString((_ctx.chat.to.groups.length == 0 && _ctx.chat.to.children.length == 0) ? _ctx.getClassNames(_ctx.chat.to.classes) : ''), 1),
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }, "グループ", -1)),
                              _createElementVNode("div", null, _toDisplayString(_ctx.getGroupNames(_ctx.chat.to.groups)), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("td", null, "タイトル", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.title), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("td", null, "本文", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.body), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("td", null, "未読数", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.chatUnReadCount + '人'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("td", null, "既読数", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.chatReadCount + '人'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("td", null, "既読者", -1)),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedReadClassChildren, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, [
                                  _createElementVNode("div", _hoisted_2, _toDisplayString(String(item.year)) + "年度 " + _toDisplayString(item.className), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: child.childId
                                    }, _toDisplayString(child.lastName + child.firstName), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("td", null, "添付ファイル", -1)),
                            _createElementVNode("td", null, [
                              (_ctx.chat.attachmentUrls?.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_img, {
                                    key: 0,
                                    src: _ctx.chat.attachmentUrls[0]
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.attachmentUrls, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "12",
                                      key: i,
                                      class: "py-2 mt-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          href: item,
                                          target: "_blank",
                                          color: "primary",
                                          variant: "outlined",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(`添付ファイル${i+1}`), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["href"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.close,
                          color: "grey",
                          variant: "text"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("閉じる", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_spacer),
                        (_ctx.isDraft)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _ctx.editMessage,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("編集", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}